function formNewsletter() {
  const form = document.getElementById('gform_7');
  form.setAttribute('data-bulldesk-skip', true);
}

window.onload = () => {
  const newsletterContent = document.getElementById('gform_7');
  if (newsletterContent) {
    formNewsletter();
  }
};
